export default __webpack_public_path__ + "static/us-enterprise-campaign-mtc-b74ecf88ecda6bedc57be75221c3ed5f.mp4";